import { GlobalStyles } from '@mui/material';
import type { CSSProperties } from 'react';
import React from 'react';

const styles: Record<string, CSSProperties> = {
  '*': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  body: {
    margin: 0,
    padding: 0,
    backgroundColor: '#131A21',
  },
  html: {
    margin: 0,
    padding: 0,
  },
};

export const GlobalStylesComponent: React.FC = () => <GlobalStyles styles={styles} />; 